import { upperFirst } from "lodash"
import { useState } from "react"
import { Controller, UseFormReturn } from "react-hook-form"

import {
  FormInput,
  InnerLabel,
  InputError,
  InputWrapper,
  TextArea,
} from "../styles/FormElementStyles"

export type TextAreaInputProps = {
  label?: string | JSX.Element
  placeholder?: string
  name: string
  id?: string
  defaultValue?: string
  autoComplete?: string
  resize?: string
  error?: any
  type?: string
  showLabel?: boolean
  autoFocus?: boolean
  rules?: { [key: string]: any }
  formHook: UseFormReturn<any>
  onChange?: () => void
}

const TextAreaInput = ({
  error,
  placeholder = "",
  label,
  name,
  id,
  autoComplete,
  formHook,
  rules,
  onChange,
  autoFocus = false,
  showLabel = true,
  defaultValue = "",
}: TextAreaInputProps) => {
  const [text, updateText] = useState<string>(defaultValue)
  const { setValue, control } = formHook

  const handleChange = (event) => {
    updateText(event.target.value)
    setValue(name, event.target.value)
    onChange?.()
    return event
  }

  const handleBlur = () => {
    updateText(text.trim())
    setValue(name, text.trim())
  }

  return (
    <FormInput>
      <InputWrapper $error={error} height={100}>
        <InnerLabel htmlFor={id} $showLabel={showLabel && text.length > 0}>
          {label}
        </InnerLabel>
        {control && (
          <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field }) => (
              <TextArea
                id={id}
                $showLabel={showLabel && text.length > 0}
                autoFocus={autoFocus}
                placeholder={placeholder}
                autoComplete={autoComplete}
                value={text}
                {...field}
                onBlur={handleBlur}
                onChange={handleChange}
              />
            )}
          />
        )}
      </InputWrapper>
      {error && (
        <InputError>{upperFirst(error.message || error.type)}</InputError>
      )}
    </FormInput>
  )
}

export default TextAreaInput
